import React, { useState, useEffect } from 'react';
import { Back, ArrowRight2 } from 'iconsax-react';
import { collection, getDocs, addDoc, query, where } from 'firebase/firestore';
import { auth, firestore } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { LoadingCards } from '../components/LoadingCards';
import {getUserData} from '../utils/FirebaseFunctions'

export const Support = () => {
  const [openTickets, setOpenTickets] = useState([]);
  const [closedTickets, setClosedTickets] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [selectedIssue, setSelectedIssue] = useState('General');
  const [creatingTicket, setCreatingTicket] = useState(false);
  const [APIloading, setAPILoading] = useState(true);
  const navigate = useNavigate();
  const [showCreateTicketBtn, setShowCreateTicketBtn] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const openTicketsQuery = query(
          collection(firestore, 'tickets'),
          where('status', '==', 'open'),
          where('uid', '==', auth?.currentUser?.uid)
        );

        const closedTicketsQuery = query(
          collection(firestore, 'tickets'),
          where('status', '==', 'closed'),
          where('uid', '==', auth?.currentUser?.uid)
        );

        const bookingsQuery = query(collection(firestore, 'bookings'));

        const [openTicketsSnapshot, closedTicketsSnapshot, bookingsSnapshot] = await Promise.all([
          getDocs(openTicketsQuery),
          getDocs(closedTicketsQuery),
          getDocs(bookingsQuery),
        ]);

        const openTicketsData = openTicketsSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        const closedTicketsData = closedTicketsSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        const bookingsData = bookingsSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        setOpenTickets(openTicketsData);
        setClosedTickets(closedTicketsData);
        setBookings(bookingsData);
        setAPILoading(false);
      } catch (error) {
        console.error('Error fetching data:', error.message);
        setAPILoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCreateTicket = async () => {
    try {
      setCreatingTicket(true);
      const userData = {};
      await getUserData(auth.currentUser.uid).then((data) => {
        userData.name = data[0]?.name;
        userData.email = data[0]?.email;
        userData.phoneNumber = data[0]?.phoneNumber;
      });
      const ticketData = {
        bookingId: selectedBooking || 'general',
        issue: selectedIssue || 'General',
        surgeryName: selectedBooking
          ? bookings.find((booking) => booking.id === selectedBooking).surgeryName
          : 'General',
        status: 'open',
        uid: auth?.currentUser?.uid,
        userData
      };

      const newTicketRef = await addDoc(collection(firestore, 'tickets'), ticketData);

      setOpenTickets((prevOpenTickets) => [...prevOpenTickets, { id: newTicketRef.id, ...ticketData }]);

      setSelectedBooking(null);
      setSelectedIssue('General');
      setCreatingTicket(false);
      setShowCreateTicketBtn(false);
    } catch (error) {
      console.error('Error creating ticket:', error.message);
      setCreatingTicket(false);
    }
  };

  return (
    <div className="p-5 w-screen font-nunito">
      {APIloading && <LoadingCards />}

      {!APIloading && !showCreateTicketBtn && (
        <>
          {(openTickets.length === 0 && closedTickets.length === 0) && <div className="h-[calc(100vh-300px)] w-full flex flex-col px-6 gap-[30px] items-center justify-center">
              <p className='text-2xl font-bold font-nunito'>No Tickets Found</p>
              <p className='text-md text-center font-nunito'>You have no active tickets, Either closed or open. Please create a ticket or reach out to <strong>admin@medisupport.com</strong> for any further details and information. </p>
            </div>}
          {openTickets.length > 0 && (
            <div className="mb-8 mt-5">
              <h2 className="text-md font-medium mb-6">Open Tickets</h2>
              <div>
                {openTickets.map((ticket) => (
                  <div
                    onClick={() => navigate('/support/' + ticket.id)}
                    key={ticket.id}
                    className="mb-2 bg-white rounded-md p-4 flex flex-col cursor-pointer"
                  >
                    {ticket.bookingId ? (
                      <p className="flex text-sm flex-row items-center">
                        {ticket.surgeryName}
                        <ArrowRight2 size="18" className="ml-auto" color="#333" variant="TwoTone" />
                      </p>
                    ) : (
                      <p className="flex flex-row text-sm items-center">
                        {`${ticket.issue} Issue`}
                        <ArrowRight2 size="18" className="ml-auto" color="#333" variant="TwoTone" />
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {closedTickets.length > 0 && (
            <div className="mb-8">
              <h2 className="text-md font-medium mb-6">Closed Tickets</h2>
              <div>
                {closedTickets.map((ticket) => (
                  <div
                    onClick={() => navigate('/support/' + ticket.id)}
                    key={ticket.id}
                    className="mb-2 bg-white rounded-md p-4 flex flex-col cursor-pointer"
                  >
                    {ticket.bookingId ? (
                      <p className="flex text-sm flex-row items-center">
                        {ticket.surgeryName}
                        <ArrowRight2 size="18" className="ml-auto" color="#333" variant="TwoTone" />
                      </p>
                    ) : (
                      <p className="flex text-sm flex-row items-center">
                        {`${ticket.issue} Issue`}
                        <ArrowRight2 size="18" className="ml-auto" color="#333" variant="TwoTone" />
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          <button
            onClick={() => setShowCreateTicketBtn(true)}
            className="bg-blue-500 fixed bottom-[130px] left-[20px] w-[calc(100vw-40px)] right-[20px] text-white py-4 px-4 rounded"
            disabled={creatingTicket}
          >
            Create Ticket
          </button>
        </>
      )}

      {showCreateTicketBtn && (
        <div className="w-full">
          <h2 className="text-md flex flex-row items-center font-medium mb-5">
            <Back size="32" color="#333" className="mr-5 cursor-pointer" onClick={() => setShowCreateTicketBtn(false)} variant="TwoTone" />
            Create a New Ticket
          </h2>
          <div className="mb-4 w-full bg-white p-5 rounded-lg mt-3">
            <label className="mr-2 text-md mb-5 w-full">Select Booking:</label>
            <select
              value={selectedBooking}
              className="w-full bg-gray-100 p-3 px-5 rounded-lg my-[20px]"
              onChange={(e) => setSelectedBooking(e.target.value)}
              disabled={creatingTicket}
            >
              <option value="">General</option>
              {bookings.map((booking) => (
                <option key={booking.id} value={booking.id}>
                  {`${booking.surgeryName}`}
                </option>
              ))}
            </select>

            <label className="mr-2 text-md mb-5 w-full">Select Issue:</label>
            <select
              value={selectedIssue}
              className="w-full bg-gray-100 p-3 px-5 rounded-lg mt-[20px]"
              onChange={(e) => setSelectedIssue(e.target.value)}
              disabled={creatingTicket}
            >
              <option value="General">General</option>
              <option value="Payment Related">Payment Related</option>
              <option value="Travel Related">Travel Related</option>
              <option value="Visa Related">Visa Related</option>
              <option value="Hospital Related">Hospital Related</option>
            </select>

            <button
              onClick={handleCreateTicket}
              className="bg-blue-500 mt-[30px] w-full text-white py-4 px-4 rounded"
              disabled={creatingTicket}
            >
              Create Ticket
            </button>
          </div>
        </div>
      )}
      <div className="w-full h-[150px]"></div>
    </div>
  );
};

export default Support;
